var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreActions = function SvgMoreActions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5.25 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5.25 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  })));
};
export default SvgMoreActions;